const legacyRedirectMap = {
  '/home': '/about',
  '/home.html': '/about',
  '/index': '/about',
  '/index.html': '/about',
  '/index.php': '/about',
  '/default.html': '/about',
  '/about.html': '/about',
  '/about.php': '/about',
  '/about-us': '/about',
  '/company': '/about',
  '/profile': '/about#companyProfile',
  '/service.html': '/service',
  '/service.php': '/service',
  '/services': '/service',
  '/solution': '/service',
  '/solution.html': '/service',
  '/solution.php': '/service',
  '/culture.html': '/culture',
  '/culture.php': '/culture',
  '/join': '/culture#socialRecruitment',
  '/join.html': '/culture#socialRecruitment',
  '/join.php': '/culture#socialRecruitment',
  '/jobs': '/culture#socialRecruitment',
  '/recruit': '/culture#socialRecruitment',
  '/contact': '/about#appointment',
  '/contact.html': '/about#appointment',
  '/contact.php': '/about#appointment'
}

const legacyPrefixRedirects = [
  { prefix: '/news', target: '/about#companyNews' },
  { prefix: '/article', target: '/about#companyNews' },
  { prefix: '/detail', target: '/about#companyNews' },
  { prefix: '/recruit', target: '/culture#socialRecruitment' }
]

function normalizeLegacyPath(path) {
  let decodedPath = path || '/'

  try {
    decodedPath = decodeURIComponent(decodedPath)
  } catch (error) {
    decodedPath = path || '/'
  }

  const normalizedPath = decodedPath
    .replace(/\/+$/, '')
    .toLowerCase()

  return normalizedPath || '/'
}

function toRouteLocation(target, sourceRoute) {
  const [path, hash = ''] = target.split('#')

  return {
    path,
    hash: hash ? `#${hash}` : '',
    query: sourceRoute.query,
    replace: true
  }
}

export function resolveLegacyRedirect(to) {
  const legacyPath = normalizeLegacyPath(to.path)
  const exactTarget = legacyRedirectMap[legacyPath]

  if (exactTarget) {
    return toRouteLocation(exactTarget, to)
  }

  const prefixTarget = legacyPrefixRedirects.find(({ prefix }) => {
    return legacyPath === prefix || legacyPath.startsWith(`${prefix}/`)
  })

  if (prefixTarget) {
    return toRouteLocation(prefixTarget.target, to)
  }

  return null
}

export default legacyRedirectMap
